// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

class ToClipboardButton {
  constructor(button) {
    this.button = button
    const toClipboardContainer = button.closest('.to-clipboard-container')
    this.input = toClipboardContainer.querySelector('input, textarea')

    this.button.addEventListener('click', () => {
      this.copyToClipboard()
    })
  }

  copyToClipboard() {
    this.input.select()
    document.execCommand('copy')
    this.button.focus()
  }

  cleanup() {
  }
}

up.compiler('.to-clipboard-button', (element) => {
  const toClipboardButton = new ToClipboardButton(element)
  return toClipboardButton.cleanup
})
